(async () => {
  if (!customElements.get('product-media')) {
    const {
      default: Swiper,
      Pagination,
      A11y,
      Navigation,
      Scrollbar,
      Thumbs,
    } = await import('swiper');
    const { Fancybox } = await import('@fancyapps/ui');

    Swiper.use([Pagination, A11y, Navigation, Scrollbar, Thumbs]);

    class ProductMedia extends HTMLElement {
      constructor() {
        super();

        this.videoAutoplay();
        this.videoReplay();

        this.thumbSlider();
        this.mainSwiper();
        this.fancybox();
      }

      /*
       * Create thumb slider
       */
      thumbSlider() {
        // Check if Swiper exists
        if (!Swiper) {
          return false;
        }

        // Get Thumbnails slider element & Set swiper options
        this.swiperThumbs = this.querySelector('[data-product-media-thumbnails-slider]');

        if (!this.swiperThumbs) return false;

        this.swiperThumbsOptions = {
          modules: [A11y, Navigation, Pagination, Scrollbar],
          threshold: 10,
          spaceBetween: 4,
          direction: 'horizontal',
          slidesPerView: 'auto',
          watchSlidesProgress: true,
          navigation: {
            nextEl: '.swiper-button-thumbnails-next',
            prevEl: '.swiper-button-thumbnails-prev',
          },
        };

        // Create Thumbnails slider
        this.swiperThumbsInstance = new Swiper(this.swiperThumbs, this.swiperThumbsOptions);

        // Rebuild Swiper in design mode after delay
        if (Shopify.designMode && this.swiperThumbsInstance) {
          window.addEventListener('shopify:section:load', () => {
            setTimeout(() => {
              this.swiperThumbsInstance.update();
            }, 300);
          });
        }
      }

      mainSwiper() {
        // Check if Swiper exists
        if (typeof Swiper == 'undefined') {
          return false;
        }

        // Get swiper element
        this.swiperElement = this.querySelector('[data-product-media-swiper]');

        // Get thumb options
        let thumbOptions;
        if (this.swiperThumbsInstance) {
          thumbOptions = {
            thumbs: {
              swiper: this.swiperThumbsInstance,
              slideThumbActiveClass: 'swiper-slide-thumb-active border-primary',
            },
          };
        }

        // Get swiper element
        this.dataOptions = this.swiperElement.dataset.options
          ? JSON.parse(this.swiperElement.dataset.options)
          : {};

        // Swiper options
        this.swiperOptions = {
          direction: 'horizontal',
          ...this.dataOptions,
          ...thumbOptions,
        };

        // Init swiper
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        // Rebuild Swiper in design mode
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }
      }

      /*
       * Create fancybox
       */
      fancybox() {
        // Check if Fancybox exists
        if (typeof Fancybox == 'undefined') {
          return false;
        }

        Fancybox.bind('[data-fancybox]', {
          animated: false,
          showClass: false,
          mainClass: 'image-zoom',
        });
      }

      videoAutoplay() {
        const videos = this.querySelectorAll('video');

        videos.forEach((video) => {
          if (video.dataset.autoplay === 'true') {
            // Add a property to track if the video has ended
            video.hasEnded = false;

            // When the video has ended, set the flag
            video.onended = () => {
              video.hasEnded = true;
            };

            // Intersection Observer for autoplay
            let observer = new IntersectionObserver(
              (entries) => {
                entries.forEach(({ isIntersecting }) => {
                  // Check if the video has ended
                  if (!video.hasEnded) {
                    if (isIntersecting) {
                      video.play();
                    } else {
                      video.pause();
                    }
                  }
                });
              },
              { threshold: video.dataset.threshold }
            );
            observer.observe(video);
          }
        });
      }

      videoReplay() {
        const videos = this.querySelectorAll('#productVideo'); // Use class if multiple videos
        const replayButtons = this.querySelectorAll('#replayButton'); // Use class for buttons

        videos.forEach((video, index) => {
          const replayButton = replayButtons[index];

          video.onended = function () {
            replayButton.style.display = 'block';
          };

          replayButton.onclick = function (e) {
            e.stopPropagation();
            video.play();
            video.hasEnded = false;
            this.style.display = 'none';
          };

          video.onplay = function () {
            replayButton.style.display = 'none';
          };
        });
      }
    }

    window.ProductMedia = ProductMedia;

    customElements.define('product-media', ProductMedia);
  }
})();
